<template>
  <div>
    <div class="vx-row mb-4">
      <div class="vx-col md:w-1/2 w-full">
        <h2>{{ $t('barman.Equipo') }}</h2>
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <div class="text-right">
          <router-link :to="{ name: 'newBarman' }">
            <vs-button type="border" class="mr-2">
              {{ $t('barman.NuevoCamarero') }}
            </vs-button>
          </router-link>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <table-data-grid :data="itemsDataGrid" :dataColumns="dataColumns" link="table">
          <template v-slot:actions="slotProps">
            <div class="dropdown-button-container">
              <router-link :to="{ name: 'editBarman', params: { id: slotProps.item.id } }">
                <vs-button class="btnx" type="filled" color="primary">
                  {{ $t('Editar') }}
                </vs-button>
              </router-link>
              <vs-dropdown>
                <vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
                <vs-dropdown-menu>
                  <ul style="min-width: 12rem">
                    <li>
                      <span
                        @click="deleteModalBarman(slotProps.item.id, slotProps.item.name)"
                        class="cursor-pointer py-3 px-4 block hover:bg-danger text-danger hover:text-white w-full"
                      >
                        <feather-icon icon="TrashIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">{{ $t('Eliminar') }}</span>
                      </span>
                    </li>
                  </ul>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </template>
          <template v-slot:active="slotProps">
            <feather-icon
              icon="CheckCircleIcon"
              svgClasses="w-5 h-5 text-success hover:text-black stroke-current"
              @click="deactiveModalBarman(slotProps.item.id, slotProps.item.name)"
            />
          </template>
          <template v-slot:deactive="slotProps">
            <feather-icon
              icon="XCircleIcon"
              svgClasses="w-5 h-5 text-danger hover:text-black stroke-current"
              @click="activeModalBarman(slotProps.item.id, slotProps.item.name)"
            />
          </template>
          <template v-slot:name="slotProps">
            {{ slotProps.item.name }}
          </template>
        </table-data-grid>
      </div>
    </div>
  </div>
</template>

<script>
import TableDataGrid from '../TableDataGrid';
import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  props: {
    restaurant: {
      type: Object,
      required: true,
    },
  },
  components: {
    TableDataGrid,
  },
  data () {
    return {
      dialog: false,
      dataColumns: [
        { dataField: 'id', caption: 'ID', visible: false },
        { caption: this.$t('Imagen'), dataType: 'image', visible: true, width: 175 },
        { dataField: 'name', caption: this.$t('Nombre'), dataType: 'text', visible: true, width: 300 },
        { dataField: 'tables', caption: this.$t('mesas'), dataType: 'text', visible: true, width: 300 },
        { dataField: 'active', caption: this.$t('Activo'), dataType: 'slot', visible: true },
      ],
    };
  },
  created () {
    this.refreshBarmans({ restaurant_id: this.restaurant.id, language: this.language });
  },
  computed: {
    ...mapGetters({
      itemsBarmans: 'getBarmans',
      language: 'getCurrentLanguage',
    }),
    itemsDataGrid () {
      const items = this.itemsBarmans;
      const results = [];
      const placeholder = process.env.VUE_APP_IMAGE_PLACEHOLDER;
      if (Object.keys(items).length) {
        items.forEach(function (item, index) {
          results[index] = {
            id: items[index].id,
            image: `<img src="${placeholder}" style="width: 175px;" class="product-img" >`,
            name: items[index].name,
            tables: '',
            active: 'deactive',
          };
          if (items[index].avatar) {
            results[index].image = `<img src="${items[index].avatar}" style="width: 175px;" class="product-img" >`;
          }
          if (items[index].tables.length > 0) {
            items[index].tables.forEach(function (table) {
              results[
                index
              ].tables += `<span class="px-4 py-1 rounded mr-2 mb-2 bg-grey-light text-sm inline-block" >${table.name}</span>`;
            });
          }
          if (items[index].active === 1) {
            results[index].active = 'active';
          }
        }, items);
      }

      return results;
    },
  },
  methods: {
    ...mapActions({
      refreshBarmans: 'refreshBarmans',
      activeBarman: 'activeBarman',
      deactiveBarman: 'deactiveBarman',
      deleteBarman: 'deleteBarman',
    }),
    ...mapMutations({
      loading: 'loading',
    }),
    deleteModalBarman (id, name) {
      const aux = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('barman.EliminarCamarero'),
        text: this.$t('barman.EliminarConfirm', { nombre: name }),
        acceptText: this.$t('Aceptar'),
        cancelText: this.$t('Cancelar'),
        accept () {
          aux.deleteBarman(id);
        },
      });
    },
    activeModalBarman (id, name) {
      const aux = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: this.$t('barman.ActivarCamarero'),
        text: this.$t('barman.ActivarConfirm', { nombre: name }),
        acceptText: this.$t('Aceptar'),
        cancelText: this.$t('Cancelar'),
        accept () {
          aux.activeBarman(id);
        },
      });
    },
    deactiveModalBarman (id, name) {
      const aux = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('barman.DesactivarBarman'),
        text: this.$t('barman.DesactivarConfirm', { nombre: name }),
        acceptText: this.$t('Aceptar'),
        cancelText: this.$t('Cancelar'),
        accept () {
          aux.deactiveBarman(id);
        },
      });
    },
  },
};
</script>

<style></style>
